module.exports = __webpack_public_path__ + "static/img/piliangshanchu.b997b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/piliangshanchu.png
// module id = SYop
// module chunks = 24